import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dfe3132"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TtnTMSFilters__holder" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = { class: "w-full flex items-center justify-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "TtnTMSFilters",
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFiltersChanged && _ctx.onFiltersChanged(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_new_input, {
        placeholder: "Номер ТТН",
        disabled: _ctx.loading,
        value: _ctx.state.ttnNumber,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.ttnNumber) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_input, {
        placeholder: "Номер рейса",
        disabled: _ctx.loading,
        value: _ctx.state.tripNumber,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.tripNumber) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_select, {
        "can-deselect": "",
        placeholder: "Город отправки",
        loading: _ctx.data_state.cities.is_loading,
        failed: _ctx.data_state.cities.is_failed,
        disabled: _ctx.loading,
        "search-without-refresh": "",
        options: _ctx.data_state.cities.list,
        value: _ctx.state.fromCityId,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.fromCityId) = $event)),
        onRefresh: _ctx.loadCities
      }, null, 8, ["loading", "failed", "disabled", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        "can-deselect": "",
        placeholder: "Город назначения",
        loading: _ctx.data_state.cities.is_loading,
        failed: _ctx.data_state.cities.is_failed,
        disabled: _ctx.loading,
        "search-without-refresh": "",
        options: _ctx.data_state.cities.list,
        value: _ctx.state.toCityId,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.toCityId) = $event)),
        onRefresh: _ctx.loadCities
      }, null, 8, ["loading", "failed", "disabled", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        "can-deselect": "",
        placeholder: "Вид перевозки",
        loading: _ctx.data_state.transport_types.is_loading,
        failed: _ctx.data_state.transport_types.is_failed,
        disabled: _ctx.loading,
        "search-without-refresh": "",
        options: _ctx.data_state.transport_types.list,
        value: _ctx.state.transportTypeIds,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.transportTypeIds) = $event)),
        onRefresh: _ctx.loadTransportTypes,
        multiselect: ""
      }, null, 8, ["loading", "failed", "disabled", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        "can-deselect": "",
        placeholder: "Статус",
        loading: _ctx.data_state.statuses.is_loading,
        failed: _ctx.data_state.statuses.is_failed,
        disabled: _ctx.loading,
        "search-without-refresh": "",
        options: _ctx.data_state.statuses.list,
        value: _ctx.state.statusIds,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.statusIds) = $event)),
        onRefresh: _ctx.loadStatuses,
        multiselect: ""
      }, null, 8, ["loading", "failed", "disabled", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        "can-deselect": "",
        placeholder: "Комментарий",
        loading: _ctx.data_state.comments.is_loading,
        failed: _ctx.data_state.comments.is_failed,
        disabled: _ctx.loading,
        "search-without-refresh": "",
        options: _ctx.data_state.comments.list,
        value: _ctx.state.commentIds,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.commentIds) = $event)),
        onRefresh: _ctx.loadComments,
        multiselect: ""
      }, null, 8, ["loading", "failed", "disabled", "options", "value", "onRefresh"]),
      _createVNode(_component_new_input, {
        placeholder: "Дата с",
        type: "date",
        disabled: _ctx.loading,
        value: _ctx.state.dateFrom,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.dateFrom) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_input, {
        placeholder: "Дата по",
        type: "date",
        disabled: _ctx.loading,
        value: _ctx.state.dateTo,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.dateTo) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_select, {
        "can-deselect": "",
        placeholder: "Период",
        disabled: _ctx.loading,
        searchable: false,
        options: _ctx.PERIODS,
        value: _ctx.state.period,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.period) = $event)),
        onChange: _ctx.onPeriodChange
      }, null, 8, ["disabled", "options", "value", "onChange"]),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--reset",
          onClick: _ctx.onFiltersReset
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--search",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ], 32))
}